module.exports = __webpack_public_path__ + "static/img/banner-default-id.3a61aaf7.png";